import React from 'react';
import styled from 'styled-components';
import useShare from '../../hooks/useShare';

const ShareIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
    <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
  </svg>
);

// ShareButton — tap to copy a deep link to clipboard, with a brief inline
// toast confirming the action. Native Web Share API integration is gated on
// SMRTSTATS-289 and will land in the hook without changing call sites.
const ShareButton = ({ url, title, text, label = 'Share' }) => {
  const { share, status } = useShare();

  const onClick = () => share({ url, title, text });

  return (
    <Wrap>
      <Button type="button" onClick={onClick} aria-label={label}>
        <ShareIcon />
        <span>{label}</span>
      </Button>
      {status === 'shared' && <Toast role="status">Shared</Toast>}
      {status === 'copied' && <Toast role="status">Link copied</Toast>}
      {status === 'failed' && <Toast $error role="status">Couldn’t share</Toast>}
    </Wrap>
  );
};

export default ShareButton;

const Wrap = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid ${(props) => props.theme.borderColor};
  background: transparent;
  color: ${(props) => props.theme.white};
  font-family: 'SatoshiMedium', sans-serif;
  font-size: 12px;
  letter-spacing: 0.3px;
  cursor: pointer;
  transition: border-color 120ms ease, background 120ms ease;

  &:hover { border-color: ${(props) => props.theme.blueish2}; }
  &:active { background: rgba(255, 255, 255, 0.04); }
`;

const Toast = styled.span`
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  padding: 4px 10px;
  border-radius: 999px;
  background: ${(props) => (props.$error ? '#3a1414' : props.theme.green)};
  color: ${(props) => (props.$error ? props.theme.white : props.theme.black)};
  font-family: 'SatoshiBold', sans-serif;
  font-size: 11px;
  letter-spacing: 0.3px;
  white-space: nowrap;
  pointer-events: none;
  animation: fadeIn 120ms ease;

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-2px); }
    to   { opacity: 1; transform: translateY(0); }
  }
`;
